const stickyHeader = {
    header: document.getElementById('header') as HTMLElement,
    mainContent: document.getElementById('mainContent') as HTMLElement,
    popups: document.getElementById('popups') as HTMLElement,
    lastScrollTop: 0,

    init() {
        this.setClass();
    },

    setClass() {

        document.addEventListener('scroll', (e) => {
            let st = window.scrollY || document.documentElement.scrollTop;
            if (st > this.lastScrollTop || (window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                this.header.classList.remove('up');
                this.header.classList.add('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.add('down');
                this.popups.classList.remove('up');
                this.popups.classList.add('down');

            } else {
                this.header.classList.add('up');
                this.header.classList.remove('down');
                this.mainContent.classList.add('up');
                this.mainContent.classList.remove('down');
                this.popups.classList.add('up');
                this.popups.classList.remove('down');
            }
            this.lastScrollTop = st <= 0 ? 0 : st;

            if (window.scrollY === 0) {
                this.header.classList.remove('up');
                this.header.classList.remove('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.remove('down');
                this.popups.classList.remove('up');
                this.popups.classList.remove('down');
            }

        },{passive: true})
    },
}

export default stickyHeader;